// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1687":"0c5bbc9351ce8f7f","4044":"469f8f0fe7af2cfa"}[chunkId] + ".css";
};